<template>
    <GChart
        type="PieChart"
        :data="chartData"
        :options="chartOptions"
    />
</template>

<script>
    export default {
        props: ['valores'],
        data() {
            return {
                chartOptions: {
                    height: 364,
                    chartArea:{width:'auto'},
                    responsive: true
                }
            }
        },
        computed: {
            chartData() {
                var data = null;
                if(this.valores) {
                    data = [
                        ['Renovados', 'No renovados'],
                        ['Renovados', this.valores.renovados],
                        ['No renovados', this.valores.no_renovados],
                        ['Nuevos abonados', this.valores.nuevos]
                    ]
                } else {
                    data = null;
                }

                return data;
            }
        }
    }
</script>
